// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLivescreenError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M24 2H0V18H11.5383C11.6104 17.2989 11.7823 16.6274 12.0397 16H2V4H22V12.2675C22.7505 12.6445 23.4265 13.148 24 13.75V2ZM11.6074 20C11.7302 20.7071 11.9556 21.3791 12.2675 22H7L8 20H11.6074Z" class="svg-bg"/>
  <path d="M20 11.6074V11H14V13H14.3335C15.5564 12.0593 17.0879 11.5 18.75 11.5C19.1763 11.5 19.5939 11.5368 20 11.6074Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10C12 12.2091 10.2091 14 8 14C5.79086 14 4 12.2091 4 10C4 7.79086 5.79086 6 8 6C10.2091 6 12 7.79086 12 10ZM10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z" class="svg-bg"/>
  <path d="M14 7H20V9H14V7Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLivescreenError is a generated icon component.
 */
let IconMedLivescreenError = IconMedLivescreenError_1 = class IconMedLivescreenError extends IconBaseElement {
    render() {
        return html `${IconMedLivescreenError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLivescreenError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLivescreenError = IconMedLivescreenError_1 = __decorate([
    customElement('zui-icon-med-livescreen-error')
], IconMedLivescreenError);
export { IconMedLivescreenError };
